// src/pages/Games.js — V18 games index.
import React from 'react';
import styled from 'styled-components';
import PageShell from '../components/PageShell';
import { CornerCard, SectionTitle, Tag, PrimaryLink } from '../components/ui';
import { color, font, halftone } from '../theme/tokens';

const gamesList = [
    {
        id: 'numsense',
        glyph: '数',
        name: '数覚',
        en: 'NUMSENSE',
        tags: ['记忆', '速算'],
        description: '在有限的时间窗口内捕捉视觉数据点。测试您的瞬时记忆缓存与快速计算逻辑。',
        path: '/games/numsense',
    },
];

const Grid = styled.div`
    display: grid;
    grid-template-columns: 360px minmax(0, 1fr);
    gap: 48px;
    align-items: stretch;
    @media (max-width: 860px) { grid-template-columns: 1fr; gap: 24px; }
`;

const Art = styled.div`
    position: relative;
    height: 300px;
    overflow: hidden;
    background: radial-gradient(circle at 50% 55%, #4a0914 0%, #1a0409 55%, ${color.void} 100%);
    border: 1px solid ${color.line};
    display: flex;
    align-items: center;
    justify-content: center;
    b {
        font-family: ${font.display};
        font-weight: 800;
        font-size: 200px;
        line-height: 1;
        color: ${color.blood};
        text-shadow: 0 0 40px rgba(200, 50, 62, 0.6);
    }
    &::after { content: ''; position: absolute; inset: 0; opacity: 0.5; ${halftone} }
    small {
        position: absolute;
        left: 14px;
        bottom: 12px;
        z-index: 1;
        font-family: ${font.mono};
        font-size: 11px;
        letter-spacing: 0.3em;
        color: ${color.text3};
    }
    @media (max-width: 860px) { height: 200px; b { font-size: 140px; } }
`;

const Text = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 18px;
    .tags { display: flex; gap: 12px; }
    .name { display: flex; align-items: baseline; gap: 18px; flex-wrap: wrap; }
    h2 { margin: 0; font-family: ${font.display}; font-weight: 800; font-size: 44px; letter-spacing: 0.2em; color: ${color.text}; }
    .en { font-family: ${font.mono}; font-size: 13px; letter-spacing: 0.4em; color: ${color.text3}; }
    p { margin: 0; max-width: 460px; font-size: 16px; line-height: 1.9; color: ${color.text2}; }
`;

function GamesPage() {
    return (
        <PageShell num="参" title="遊戯" en="GAMES" quote="世界は終わらない。終わらせない。" sideLabel="收录">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <SectionTitle jp="収録" cn="游戏" />
                {gamesList.map((game, i) => (
                    <CornerCard key={game.id} pad="36px">
                        <Grid>
                            <Art>
                                <b aria-hidden="true">{game.glyph}</b>
                                <small>No.{String(i + 1).padStart(2, '0')}</small>
                            </Art>
                            <Text>
                                <div className="tags">{game.tags.map((t) => <Tag key={t}>{t}</Tag>)}</div>
                                <div className="name"><h2>{game.name}</h2><span className="en">{game.en}</span></div>
                                <p>{game.description}</p>
                                <div><PrimaryLink to={game.path}>开始</PrimaryLink></div>
                            </Text>
                        </Grid>
                    </CornerCard>
                ))}
            </div>
        </PageShell>
    );
}

export default GamesPage;
